import React from 'react';
import { Col, Form, Switch } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useCustomReportManagerContext } from '../../context';
import { CustomItemSwitch } from './styles';

const { useFormInstance, useWatch } = Form;

export const RequireCharacteristics: React.FC = () => {
	const form = useFormInstance();
	const characteristics = useWatch('has_characteristics', form);
	const { handleStepsSequence } = useCustomReportManagerContext();

	function handleOnChange(): void {
		handleStepsSequence();
	}

	return (
		<Col xs={24}>
			<CustomItemSwitch name={['has_characteristics']} label={I18n.get('Require characteristics')}>
				<Switch checked={characteristics} onChange={handleOnChange} />
			</CustomItemSwitch>
		</Col>
	);
};
